// PostHog analytics — gameplay telemetry only.
//
// Initialized once at boot. The host is a self-hosted PostHog proxy
// (gpdr.ubris.dev) so requests look first-party and don't get blocked
// by aggressive ad blockers. We disable autocapture and session
// recording — every event is explicitly chosen below.

import posthog from "posthog-js";

const POSTHOG_KEY  = "phc_q6HoBB47U3bNHHyXYwy6Xm5aA7nsrVLjACfeSP92qDnr";
const POSTHOG_HOST = "https://gpdr.ubris.dev";

let booted = false;

export function initAnalytics(): void {
  if (booted) return;
  booted = true;
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      // Only build PostHog "person" profiles for users we explicitly identify
      // (i.e. once they pick a pilot name and join an arena). Anonymous boot
      // events still flow but don't burn person quota.
      person_profiles: "identified_only",
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: false,             // every event is intentional
      disable_session_recording: true,
      disable_surveys: true,
      // Sanity: never persist raw form contents.
      mask_all_text: true,
    });
  } catch (err) {
    console.warn("PostHog init failed", err);
  }
}

export function track(event: string, props?: Record<string, unknown>): void {
  if (!booted) return;
  try { posthog.capture(event, props); } catch { /* noop */ }
}

export function identifyPilot(pilotId: string, props?: Record<string, unknown>): void {
  if (!booted) return;
  try { posthog.identify(pilotId, props); } catch { /* noop */ }
}

export function resetIdentity(): void {
  if (!booted) return;
  try { posthog.reset(); } catch { /* noop */ }
}
